import { ThermometerGraph } from '../../../logbook/views/ThermometerGraph';
import {
    Card,
    Exercise,
    LabelBody,
    LabelBodyHeadline,
    LabelHeader4,
    LabelHeader5,
} from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';

export const exerciseData45: ExerciseData = {
    ExerciseView: Module4Exercise5,
    dataKeys: [],
    questions: [],
};

function Module4Exercise5({}: ExerciseViewProps) {
    return (
        <Exercise title="Tjek ind med dig selv" className="mt-20">
            <LabelHeader4>Dit tilbageblik</LabelHeader4>
            <LabelBody className="mt-10">
                Her kan du se udviklingen i dine tjek-ins gennem forløbet.
            </LabelBody>
            <ThermometerGraph className="my-30" />
            <Card>
                <LabelHeader5>Hvilke mønstre ser du?</LabelHeader5>
                <LabelBody className="mt-10">
                    For at forstå udviklingen i din temperatur gennem de sidste
                    par uger, kan du overveje disse spørgsmål:
                </LabelBody>
                <LabelBodyHeadline className="mt-20">
                    Hvordan er den overordnede udvikling gennem de seneste uger?
                </LabelBodyHeadline>
                <LabelBody>
                    Er min oplevelse af at være presset blevet mindre, så
                    temperaturen er faldet? Eller er den det samme, eller måske
                    steget?
                </LabelBody>
                <LabelBodyHeadline className="mt-20">
                    Er der bestemte uger, hvor du havde det mest pres?
                </LabelBodyHeadline>
                <LabelBody>
                    Kan du genkende sammenhænge med begivenheder, opgaver,
                    hverdagen og dit niveau af pres i bestemte uger?
                </LabelBody>
                <LabelBodyHeadline className="mt-20">
                    Hvad du gjort for at påvirke udviklingne i din temperatur?
                </LabelBodyHeadline>
                <LabelBody>
                    Er der noget du har gjort anderledes, som du kan tage med
                    dig fremover?
                </LabelBody>
            </Card>
        </Exercise>
    );
}
